import {
  GET_INVITATIONS,
  ADD_INVITATION,
  UPDATE_INVITATION,
  DELETE_INVITATION,
  INVITATIONS_LOADING,
  GET_INVITATION_FILTER_VALUES
} from '../actions/types';

const initialState = {
  invitations: [],
  loading: false,
  pagination: {
    total: 0,
    page: 1,
    limit: 50,
    totalPages: 0,
    hasNextPage: false,
    hasPrevPage: false
  },
  filterValues: {
    emails: [],
    groups: [],
    roles: ['student', 'instructor', 'admin'],
    statuses: ['pending', 'archived']
  }
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_INVITATIONS:
      return {
        ...state,
        invitations: action.payload.data || action.payload,
        pagination: action.payload.pagination || state.pagination,
        loading: false
      };
    case GET_INVITATION_FILTER_VALUES:
      return {
        ...state,
        filterValues: action.payload.data || action.payload
      };
    case DELETE_INVITATION:
      return {
        ...state,
        invitations: state.invitations.filter(invitation => invitation._id !== action.payload)
      };
    case ADD_INVITATION:
      return {
        ...state,
        invitations: [action.payload, ...state.invitations]
      };
    case UPDATE_INVITATION:
      return {
        ...state,
        invitations: state.invitations.map(invitation =>
          invitation._id === action.payload._id ? action.payload : invitation
        )
      };
    case INVITATIONS_LOADING:
      return {
        ...state,
        loading: true
      };
    default:
      return state;
  }
}
